export default __webpack_public_path__ + "static/media/infobanner3.91302462.svg";